import { AxiosError } from 'axios';
import { ACTIONS, Fetcher, RequestInvocation } from './types';

export const start = () => ({
  type: ACTIONS.START,
});

export const success = (data: any) => ({
  type: ACTIONS.SUCCESS,
  payload: data,
});

export const error = (error: string, axiosError: AxiosError | null = null) => ({
  type: ACTIONS.ERROR,
  payload: [error, axiosError],
});

export const reset = (data: any) => ({
  type: ACTIONS.RESET,
  payload: data,
});

export const fetchData = (dispatch: any) => {
  dispatch(start());

  return (fetcher: Fetcher) => {
    fetcher
      .fetch()
      .then((data) => {
        dispatch(success(data));
      })
      .catch((err) => {
        dispatch(error('Error response to be specified.'));
      });
  };
};

export const runRequest = <T = any>(dispatch: any) => {
  dispatch(start());

  return (request: RequestInvocation<T>) => {
    request()
      .then((data) => {
        dispatch(success(data.data));
      })
      .catch((err) => {
        dispatch(error(err.response, err));
      });
  };
};
